"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const deserializeBankAccount = ({ bankAccountId, bban, iban, companyId, creatorId, currency, isDeleted }) => ({
    id: bankAccountId,
    bban,
    iban,
    companyId,
    creatorId,
    currency,
    isDeleted
});
exports.default = deserializeBankAccount;
